var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-outline",
    transform: "translate(-3 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    d: "M5.25-1.5h28.5A6.758,6.758,0,0,1,40.5,5.25v19.5a6.758,6.758,0,0,1-6.75,6.75H5.25A6.758,6.758,0,0,1-1.5,24.75V5.25A6.758,6.758,0,0,1,5.25-1.5Zm28.5,30a3.754,3.754,0,0,0,3.75-3.75V5.25A3.754,3.754,0,0,0,33.75,1.5H5.25A3.754,3.754,0,0,0,1.5,5.25v19.5A3.754,3.754,0,0,0,5.25,28.5Z",
    transform: "translate(4.5 9)",
    fill: "#00828b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M43.5,20.813H4.5V15.188h39Z",
    fill: "#00828b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M12,25.313h4.5a2.813,2.813,0,0,1,2.813,2.813V30A2.813,2.813,0,0,1,16.5,32.813H12A2.813,2.813,0,0,1,9.188,30V28.125A2.813,2.813,0,0,1,12,25.313Z",
    fill: "#00828b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOutline);
export default __webpack_public_path__ + "static/media/card-outline.ee1500f6d391082307bb6836442bddfb.svg";
export { ForwardRef as ReactComponent };